(function () {
  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");
    if (!annBar) return;

    // Cache the height once. The announcement bar doesn't change size on scroll.
    let annBarHeight = annBar.getBoundingClientRect().height;

    // Recalc height only when the bar itself resizes (new content, breakpoint, etc.)
    const resizeObserver = new ResizeObserver(() => {
      annBarHeight = annBar.getBoundingClientRect().height;
    });
    resizeObserver.observe(annBar);

    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();

      // 20 thresholds is more than enough for smooth height interpolation.
      // The original used 1000, firing the callback ~1000x per scroll direction
      // and causing a forced reflow on every one (Lighthouse flagged 89ms).
      const thresholds = Array.from({ length: 21 }, (_, i) => i / 20);

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const height = entry.isIntersecting
              ? (annBarHeight * entry.intersectionRatio).toFixed(2)
              : 0;
            document.documentElement.style.setProperty("--ann-height", `${height}px`);
          });
        },
        { threshold: thresholds }
      );

      observer.observe(annBar);
    };

    createObserver();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();